export default "__VITE_ASSET__72d98ffc__"